export default __webpack_public_path__ + "static/impact-report-e65861105642d87c57e76e40065ce111.jpg";